import { db } from '../../utils/firebase';

export const getAllMedia = async () => {
  const content = [];
  const querySnapshot = await db.collection("media_coverage").get();
  const promises = [];
  querySnapshot.forEach(doc => {
    // doc.data() is never undefined for query doc snapshots
    const { title, order } = doc.data();
    // get children for each section
    promises.push(
      db
        .collection("media_coverage")
        .doc(doc.id)
        .collection("children")
        .get()
    );
    content.push({ title, order, children: [] });
  });

  const snapshots = await Promise.all(promises);
  let i = 0;
  snapshots.forEach(querySnapshot1 => {
    const childrens = [];
    querySnapshot1.forEach(doc => {
      // get single children
      const { content, date, images } = doc.data();
      childrens.push({ content, date, images });
    });
    childrens.sort((a, b) => b.date.seconds - a.date.seconds);
    content[i].children = childrens;
    i++;
  });

  content.sort((a, b) => a.order - b.order);
  return content;
}